import React from 'react'

import './PageCenterContent.scss'

export default props =>
  <div className="page-container" style={props.style}>
    {props.children}
  </div>
